import {
  Home,
  TrendingUp,
  Building2,
  HardHat,
  Landmark,
  Stethoscope,
  Scale,
  RefreshCcw,
  Compass,
  LandPlot,
  Factory,
  Ship,
  Boxes,
  Briefcase,
} from "lucide-react";

export const COMPANY = {
  name: "Invesmo Pty Ltd",
  tagline: "Debt Capital · Investment · Development Advisory",
  abn: "83 916 108 443",
  crn: "113965",
  aggregator: "LMG Broker Services Pty Ltd",
  acl: "389 192",
  afca: "71710",
  afcaMember: "113965",
  email: "anubhav@invesmo.com.au",
  phone: "+614219165401",
  phoneDisplay: "+61 421 916 5401",
  address: "Camberwell VIC 3124, Australia",
  hours: "Monday – Friday, 9:00am – 5:30pm",
  domain: "www.invesmo.com.au",
  logo: "/invesmo-logo.png",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1706164971302-e30c0640cc3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMG5pZ2h0fGVufDB8fHx8MTc9MDU1MTI5NXww&ixlib=rb-4.1.0&q=85",
  propertyDay: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjBob21lJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc5MDU1MTI5NXww&ixlib=rb-4.1.0&q=85",
  principal: "https://customer-assets-rejwkqb3.emergentagent.net/job_invesmo-consult/artifacts/sl4debfg_AnuPrakashProfilePicInvesmo.jpeg",
  camberwell: "https://images.unsplash.com/photo-1743841728238-1676ca06f01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBtZWxib3VybmUlMjBhcmNoaXRlY3R1cmUlMjBsdXh1cnklMjBob21lJTIwaW50ZXJpb3IlMjBleGVjdXRpdmUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTA1NTEyOTF8MA&ixlib=rb-4.1.0&q=85",
  interior: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHxfHxtb2Rlcm4lMjBsdXh1cnklMjBob21lJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc5MDU1MTI5NXww&ixlib=rb-4.1.0&q=85",
  nightEstate: "https://images.unsplash.com/photo-1783490244502-cd5f236e3780?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGFyY2hpdGVjdHVyZSUyMG5pZ2h0fGVufDB8fHx8MTc9MDU1MTI5NXww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "home-loans",
    title: "Home Loans",
    icon: Home,
    short: "First home, next home or refinancing the one you love — structured around your life, not a bank's checklist.",
    points: ["First home buyers & upgraders", "Refinancing & rate reviews", "Offset, split & redraw structures", "Construction & renovation loans"],
  },
  {
    slug: "investment-property",
    title: "Investment Property Loans",
    icon: TrendingUp,
    short: "Portfolio lending engineered for yield, gearing and long-term capital growth.",
    points: ["Interest-only & P&I structures", "Equity release & portfolio lending", "Cross-collateralisation strategy", "Rent, yield & serviceability assessment"],
  },
  {
    slug: "commercial-business",
    title: "Commercial & Business Loans",
    icon: Building2,
    short: "Working capital, premises, equipment and growth funding for established businesses.",
    points: ["Commercial property purchase", "Business acquisition & expansion", "Equipment, vehicle & fit-out finance", "Cash-flow, trade & invoice facilities"],
  },
  {
    slug: "development-finance",
    title: "Development Finance",
    icon: HardHat,
    short: "From duplex to multi-lot subdivision — senior debt, mezzanine and construction funding.",
    points: ["Residential & commercial development", "Construction & residual stock facilities", "Mezzanine & preferred equity", "Feasibility-driven structuring"],
  },
  {
    slug: "smsf-lending",
    title: "SMSF Lending",
    icon: Landmark,
    short: "Limited recourse borrowing arrangements to hold property inside your self-managed super fund.",
    points: ["LRBA residential & commercial property", "Lender compliance navigation", "Structuring alongside your accountant", "Refinancing existing SMSF loans"],
  },
  {
    slug: "doctors-specialists",
    title: "Doctors & Medical Specialists",
    icon: Stethoscope,
    short: "Medico lending packages with higher LVRs, waived LMI and sharper pricing for medical professionals.",
    points: ["Up to 90–95% LVR with LMI waived*", "Home, investment & rooms purchase", "Practice, fit-out & equipment finance", "Intern-to-specialist career pathways"],
  },
  {
    slug: "accountants-lawyers",
    title: "Accountants & Legal Professionals",
    icon: Scale,
    short: "Professional packages that recognise your qualifications, income trajectory and partnership structures.",
    points: ["Preferential LVR & pricing tiers", "Partnership & practice finance", "Investment portfolio strategy", "Complex & variable income assessment"],
  },
  {
    slug: "business-restructure",
    title: "Business Restructure",
    icon: RefreshCcw,
    short: "Reorganise debt, release pressure and reposition your business for its next chapter.",
    points: ["Debt consolidation & refinancing", "ATO debt solutions", "Creditor negotiation support", "Turnaround & bridging funding"],
  },
  {
    slug: "debt-advisory",
    title: "Debt Capital & Advisory",
    icon: Compass,
    short: "Strategic debt structuring and capital advice — the discipline at the heart of Invesmo.",
    points: ["Capital structure review", "Multi-lender tendering", "Interest-rate risk strategy", "Ongoing portfolio management"],
  },
];

export const SERVICE_OPTIONS = [...SERVICES.map((s) => ({ slug: s.slug, title: s.title })), { slug: "general-enquiry", title: "General Enquiry" }];

export const LENDERS = [
  "ANZ", "Commonwealth Bank", "Westpac", "NAB", "Macquarie", "Bankwest",
  "St.George", "Suncorp", "Bendigo Bank", "AMP", "Pepper Money", "Liberty",
  "La Trobe Financial", "Resimac", "Bluestone", "Athena",
];

export const DIFFERENCE = [
  {
    num: "01",
    title: "We understand you",
    body: "Your goals, family, risk appetite and timeline shape every recommendation. Advice starts with listening — not with a product.",
  },
  {
    num: "02",
    title: "We understand your business",
    body: "Cash-flow cycles, entity structures, seasonal pressure and growth ambition — we speak the language of business because we advise it daily.",
  },
  {
    num: "03",
    title: "A relationship, not a transaction",
    body: "Annual reviews, rate watch and proactive restructuring. Settlement is the start of the engagement, not the end of it.",
  },
  {
    num: "04",
    title: "Always the best option available",
    body: "With 100+ lenders on the LMG panel, we search the whole market for your best available option — not a single lender's shelf.",
  },
];

export const NETWORK_STATS = [
  { value: "100+", label: "lenders on the LMG panel" },
  { value: "6,000+", label: "brokers in the LMG community" },
  { value: "1M+", label: "clients supported across the network" },
  { value: "60 min", label: "initial consultation, no obligation" },
];

export const AUDIENCES = [
  {
    slug: "property-developers",
    title: "Property Developers",
    icon: Building2,
    hook: "Construction, residual stock and mezzanine funding structured around your feasibility — not a bank's template.",
    points: ["Construction & development finance", "Residual stock facilities", "Mezzanine & preferred equity", "Multi-lot subdivision funding"],
  },
  {
    slug: "land-developers",
    title: "Land Developers",
    icon: LandPlot,
    hook: "Land banking, subdivision and staged-release funding that moves at the speed of your approvals.",
    points: ["Land acquisition & land banking", "Staged subdivision finance", "DA / permit-stage funding", "Civil works & infrastructure facilities"],
  },
  {
    slug: "manufacturers",
    title: "Manufacturers",
    icon: Factory,
    hook: "Plant, equipment and working capital matched to your production cycle and order book.",
    points: ["Machinery & equipment finance", "Working capital facilities", "Commercial premises purchase", "Trade & invoice finance"],
  },
  {
    slug: "importers-exporters",
    title: "Importers & Exporters",
    icon: Ship,
    hook: "Trade finance for goods in motion — structured with an eye on currency and cash-conversion cycles.",
    points: ["Import / export trade lines", "Letters of credit", "Inventory & invoice finance", "FX-aware facility structuring"],
  },
  {
    slug: "wholesale-traders",
    title: "Wholesale Traders",
    icon: Boxes,
    hook: "Stock and debtor finance that scales with your order book and smooths seasonal peaks.",
    points: ["Inventory & stock finance", "Debtor / invoice discounting", "Warehouse premises & fit-out", "Seasonal cash-flow facilities"],
  },
  {
    slug: "professionals",
    title: "Professionals — CPAs & Doctors",
    icon: Briefcase,
    hook: "Medico and professional packages that reward your qualifications with sharper pricing and higher LVRs.",
    points: ["LMI waived up to 90–95% LVR*", "Practice & partnership finance", "Home & investment lending", "Complex & variable income assessment"],
  },
  {
    slug: "investors",
    title: "Property Investors",
    icon: TrendingUp,
    hook: "Portfolio lending engineered for yield, gearing and long-term capital growth.",
    points: ["Equity release & portfolio scaling", "Interest-only & split structures", "Cross-collateralisation strategy", "Rent, yield & serviceability planning"],
  },
  {
    slug: "smsf-investors",
    title: "SMSF Investors",
    icon: Landmark,
    hook: "Limited recourse borrowing to hold property inside your super — structured alongside your accountant.",
    points: ["LRBA residential & commercial", "Lender compliance navigation", "Refinancing existing SMSF loans", "Coordination with your accountant"],
  },
];

export const fmtAUD = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n);

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
